import initBrandsPage from "components/brands/published_page/component";

document.addEventListener("DOMContentLoaded", initBrandsPage);
